document.addEventListener('DOMContentLoaded', () => {
    const liItem = document.querySelectorAll('.new_section-faq .item');
    
    liItem.forEach(item => {
        item.addEventListener('click', () => {
            // Si el elemento en el que se hizo clic ya tiene la clase 'active'
            if(item.classList.contains('active')){
                // La eliminamos
                item.classList.remove('active');
            }else{
                // Primero, quitamos la clase 'active' a todos los elementos
                liItem.forEach(el => el.classList.remove('active'));
                // Luego, agregamos la clase 'active' al elemento en el que se hizo clic
                item.classList.add('active');
            }
        });
    });
});

